const PENNYLANE_FIELD_LABELS = {
    name: 'Prospect > Raison sociale',
    regNo: 'Prospect > SIREN',
    vatNumber: 'Prospect > N° de TVA intracommunautaire',
    billingAddress: 'Prospect > Adresse de facturation',
    'billingAddress.address': 'Prospect > Adresse',
    'billingAddress.postalCode': 'Prospect > Code postal',
    'billingAddress.city': 'Prospect > Ville',
    'billingAddress.countryAlpha2': 'Prospect > Pays',
    'deliveryAddress.address': 'Prospect > Adresse de livraison',
    'deliveryAddress.postalCode': 'Prospect > Code postal de livraison',
    'deliveryAddress.city': 'Prospect > Ville de livraison',
    'deliveryAddress.countryAlpha2': 'Prospect > Pays de livraison',
    date: "Devis > Date d'émission",
    deadline: 'Devis > Date de validité',
    invoiceLines: 'Devis > Lignes de devis',
    'invoiceLines.vatRate': 'Devis > Ligne {line} — Taux de TVA',
};

// Les chemins de violation portent l'index de la ligne fautive et, en mise à jour, un segment "create"
// propre au format de l'API : « invoiceLines.create[0].vatRate » désigne le même champ que « invoiceLines[0].vatRate ».
function normalizePath(name) {
    return name.replace(/\[\d+]/g, '').replace('invoiceLines.create', 'invoiceLines');
}

export function getPennylaneFieldLabel(name) {
    if (!name) {
        return name;
    }

    const label = PENNYLANE_FIELD_LABELS[normalizePath(name)];

    if (undefined === label) {
        return name;
    }

    const lineIndex = name.match(/\[(\d+)]/)?.[1];

    return undefined === lineIndex ? label : label.replace('{line}', String(Number(lineIndex) + 1));
}
